// importation des bibliothèques de modules node
import React, {useEffect, useState} from 'react';
import {Button, Card, Form} from 'react-bootstrap';
import {useNavigate, useParams} from 'react-router-dom';

// importation du profil layout wrapper
import OldPersonnelProfileLayout from './OldPersonnelProfileLayout';

import PersonnelService from '../../services/PersonnelService';

const UnarchivePersonnel = () => {
    const [personnel, setPersonnel] = useState(null);
    const {id} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        Promise.all([PersonnelService.getPersonnel(id)]).then(([personnelData]) => {
            setPersonnel(personnelData.data);
        });
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            const personnelData = new FormData();

            personnelData.append('archived', false);

            // Call the PersonnelService to update the personnel
            await PersonnelService.updatePersonnel(id, personnelData);

            // Redirect the user to the list of personnels
            navigate('/archives/personnel');
        } catch (error) {
            console.error(
                "Erreur lors de la désarchivage des informations de ce personnel",
                error
            );
        }
    };

    return (
        <OldPersonnelProfileLayout>
            {personnel && (
                <>
                    {/*  Form  */}
                    <Form className="mb-3" onSubmit={handleSubmit}>
                        <Card className="border-0">
                            <Card.Header>
                                <div className="mb-3 mb-lg-0">
                                    <h3 className="mb-0">
                                        Désarchiver{' '}
                                        <span className="text-uppercase">
											{personnel.nom || ''}
										</span>
                                    </h3>
                                    <p className="mb-0">Réintégrer le profil de ce personnel dans la liste.</p>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <span className="text-warning h4">Attention</span>
                                <p>
                                    En désarchivant le profil de ce personnel, il réapparaîtra
                                    dans la liste principale des personnels de l'établissement.
                                </p>
                                <Button variant="warning" type="submit">
                                    Désarchiver le profil de ce personnel
                                </Button>
                            </Card.Body>
                        </Card>
                    </Form>
                </>
            )}
        </OldPersonnelProfileLayout>
    );
};

export default UnarchivePersonnel;
